import React from 'react';
import CustomChip from 'common-components/CustomChip';

// Single source of truth for the investor onboarding-source feature.
// Mapping (by investor `source`) mirrors the investor-backend filter in
// getAllMergeInvestorList:
//   Database -> source = "backrr_imported"
//   Invited  -> source in ["startup_invitation", "startup_public_profile"]
//   Self     -> source = "self_onboarding"

// Query param sent to the listing endpoint.
export const ONBOARDING_FILTER_KEY = 'onboarding_status';

// Options for the filter dropdown.
export const INVESTOR_ONBOARDING_STATUSES = [
  { label: 'Database', value: 'import' },
  { label: 'Invited', value: 'invite' },
  { label: 'Self', value: 'registered' },
];

// Derive an investor's onboarding source (for the table chip) from its `source`.
export const getInvestorOnboardingStatus = (item) => {
  switch (item?.source) {
    case 'backrr_imported':
      return { value: 'import', label: 'Database', bg: '#E7EEFD', color: '#3538CD' };
    case 'startup_invitation':
    case 'startup_public_profile':
      return { value: 'invite', label: 'Invited', bg: '#FEF3E7', color: '#B25E09' };
    case 'self_onboarding':
      return { value: 'registered', label: 'Self', bg: '#D2F2E7', color: '#1B8662' };
    default:
      return null;
  }
};

// Renders the onboarding-source chip for a table row (or "-" when unknown).
export const OnboardingStatusChip = ({ item }) => {
  const status = getInvestorOnboardingStatus(item);
  if (!status) return '-';
  return (
    <CustomChip
      label={status.label}
      sx={{ bgcolor: status.bg, color: status.color, fontWeight: 700, fontSize: '0.7rem' }}
    />
  );
};
